const currency = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'NZD' });

const setup = (root, index) => {
	const mode = root.dataset.mode;
	const products = JSON.parse(root.dataset.products);
	const key = `fc-${index}-`;

	const $ = (cls) => root.querySelector(`.${cls}`);
	const meters = $('fc-meters');
	const metersLabel = $('fc-meters-label');
	const total = $('fc-total');

	const idx = (group) => {
		const checked = root.querySelector(`input[name="${key}${group}"]:checked`);
		return checked ? parseInt(checked.value, 10) : 0;
	};

	const section = (el, title, group, labels, onChange) => {
		let prev = idx(group);
		if (prev >= labels.length) prev = 0;

		el.innerHTML = '';

		if (title && labels.length) {
			const heading = document.createElement('h4');
			heading.textContent = title;
			el.appendChild(heading);
		}

		labels.forEach((text, i) => {
			const label = document.createElement('label');
			label.classList.add('Radio');

			const input = document.createElement('input');
			input.type = 'radio';
			input.name = `${key}${group}`;
			input.value = i;
			input.checked = i === prev;
			input.addEventListener('change', onChange);

			label.appendChild(input);
			label.appendChild(document.createTextNode(` ${text}`));
			el.appendChild(label);
		});
	};

	const update = () => {
		const p = products[idx('p')];
		const m = parseInt(meters.value, 10) || 0;
		let amount = 0;

		metersLabel.textContent = m;
		meters.closest('.fc-slider').style.setProperty('--ratio', (m - meters.min) / (meters.max - meters.min));

		if (mode === 'fence') {
			amount = (p.heights[idx('h')] || p.heights[0]).price * m;
		} else if (mode === 'gates') {
			const g = p.gates[idx('g')] || p.gates[0];
			amount = (g.heights[idx('h')] || g.heights[0]).price;
		} else {
			amount = (p.slats[idx('s')] || p.slats[0]).price * m;
		}

		total.textContent = currency.format(amount);
	};

	const renderGateHeights = () => {
		const p = products[idx('p')];
		const g = p.gates[idx('g')] || p.gates[0];

		section($('fc-heights'), 'Gate', 'h', g.heights.map((h) => `${h.label} Height`), update);
		update();
	};

	const render = () => {
		const p = products[idx('p')];
		const profileEl = $('fc-profiles');
		const heightEl = $('fc-heights');
		const slatEl = $('fc-slats');

		profileEl.innerHTML = heightEl.innerHTML = slatEl.innerHTML = '';

		if (mode === 'fence') {
			section(heightEl, null, 'h', p.heights.map((h) => `${h.label} Height`), update);
		} else if (mode === 'gates') {
			section(profileEl, 'Profile', 'g', p.gates.map((g) => g.label), renderGateHeights);
			renderGateHeights();
			return;
		} else {
			section(heightEl, null, 'h', ['1800mm Height'], update);
			section(slatEl, 'Slat:', 's', p.slats.map((s) => s.label), update);
		}

		update();
	};

	meters.addEventListener('input', update);

	if (mode === 'gates') $('fc-length').style.display = 'none';

	if (products.length > 1) {
		section($('fc-products'), 'Pricing Estimate:', 'p', products.map((p) => p.name), render);
	}

	render();
};

const module = {
	init() {
		document.querySelectorAll('.fencing-calculator').forEach(setup);
	}
};

export { module as fencingCalculator };
